import React, { Component } from 'react';
import Select from 'react-select';
import withRouter from "../../Utils/withRouter";
import Swal from "sweetalert2";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { currentDateAndTime, decodeData, bloodGroupOptions, genderOptions, titleOptions, maritalStatusOptions } from '../../Constants/constants';

class PersonalDetails extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      profile_picture: null,
      selectedProfilePicture: null,
      reporting_manager_id: 0,
      company_employee_type_id: 0,
      company_employee_category_id: 0,
      blood_Group: '',
      From_date: "",
      To_date: "",
      employee_code: "",
      is_contract_employee: '0',
      Title: "",
      employee_gender: "",
      Date_of_birth: "",
      physically_challenged: "",
      international_employee: "",
      religion: "",
      nationality: "",
      marital_status: "",
      employee_joining_date: "",
      Designation: [],
      employee_verified_row: [],
      Grade: [],
      Department: [],
      Location: [],
      location_id: 0,
      department_id: 0,
      designation_id: 0,
      grade_id: "",
      SelectLevels: "",
      LinkValidDays: "",
      employee_name: "",
      biometric_code: "",
      employee_email_address: "",
      employee_mobile_number: "",
      employee_address: "",
      employee_official_email: "",
      required_documents: [],
      required_letters: [],
      rows: [],
      letter_rows: [],
      employee_category_row: [],
      employee_type_row: [],
      permanent_Address: '',
      pinCode: '',
      reporting_Manager: '',
      enter_State: '',
      state_options: [],
      current_Address: '',
      errors: {},
      decodedData: [],
    };
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetDesignationMasters();
      this.GetGradeMasters();
      this.GetDepartmentMasters();
      this.GetLocationMasters();
      this.getStateAndDesignation();
      this.GetInfo();
      this.GetEmployeesVerifiedList();
      this.GetEmployeesTypeList();
      this.GetEmployeesCategoryList();
    });
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }


  GetInfo = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetEmployeeInfo?employee_id=${this.props.params.employee_id}`, { headers }).then((response) => {
      const { data, success } = response.data;
      if (success === true) {
        console.log("data[0].employee_state",data[0].employee_state);
        
        this.setState(
          {
            employee_code: data[0].employee_code,
            employee_name: data[0].employee_name,
            biometric_code: data[0].biometric_code,
            profileUrl: data[0]?.employee_profile_url,
            selectedProfilePicture: data[0]?.employee_profile_url,
            selectedProfilePictureName: data[0]?.employee_profile_picture,
            employee_mobile_number: data[0].employee_mobile_number,
            is_contract_employee: data[0].is_contract_employee?.toString(),
            employee_email_address: data[0].employee_email_address,
            employee_gender: data[0].employee_gender,
            Date_of_birth: data[0].date_of_birth,
            physically_challenged: data[0].physically_challenged,
            international_employee: data[0].international_employee,
            religion: data[0].religion,
            nationality: data[0].nationality,
            marital_status: data[0].marital_status,
            employee_joining_date: data[0].employee_joining_date,
            designation_id: data[0].designation_id,
            department_id: data[0].department_id,
            grade_id: Number(data[0].grade_id),
            location_id: data[0].location_id,
            employee_address: data[0].employee_address,
            reporting_manager_id: Number(data[0].reporting_manager_id),
            employee_official_email: data[0].employee_official_email,
            blood_Group: data[0].blood_group,
            From_date: data[0].contract_from_date,
            To_date: data[0].contract_to_date,
            Title: data[0].employee_title,
            company_employee_category_id: data[0].employee_category,
            company_employee_type_id: data[0].employee_type,
            permanent_Address: data[0].employee_permanent_address,
            pinCode: data[0].pin_code,
            enter_State: Number(data[0].employee_state),
          }
        )
      }
    });
  }

  GetEmployeesVerifiedList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Employees/GetEmployeesVerifiedList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            employee_verified_row: data.data.map((row) => ({
              value: row?.employee_id,
              label: `${row?.employee_code} ${row?.employee_name}`
            }))
          }));
        }
      });
  }

  GetEmployeesTypeList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetEmployeeTypeList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            employee_type_row: data.data.map((row) => ({
              value: row.company_employee_type_id,
              label: row.company_employee_type
            }))
          }));
        }
      });
  }

  GetEmployeesCategoryList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Masters/GetEmployeeCategoryList`, { headers })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            employee_category_row: data.data.map((row) => ({
              value: row.company_employee_category_id,
              label: row.company_employee_category
            }))
          }));
        }
      });
  }

  handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
        // Validate file size and type
        const allowedTypes = ["image/jpeg", "image/png"];
        const maxFileSize = 1 * 1024 * 1024; 
        if (!allowedTypes.includes(file.type)) {
            this.setState({ fileError: "Invalid file type. Only jpg and png are allowed." });
            return;
        }
        if (file.size >= maxFileSize) {
            this.setState({ fileError: "File size must be less than 1MB." });
            return;
        }
        

 
        const reader = new FileReader();
        reader.onload = (event) => {
            this.setState({
              fileError: "", 
                profileUrl: "", 
                profile_picture: file, 
                selectedProfilePicture: event.target.result, 
                selectedProfilePictureName: file.name, 
                fileError: null, 
            });
        };
        reader.readAsDataURL(file); 
    }
  };

  removeProfilePicture = () => {
    this.setState({
      // profileUrl:"",
      profile_picture: null,
      selectedProfilePicture: null,
      selectedProfilePictureName: '',
    });
  };

  GetDesignationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.designation;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Designation: data.map((row) => ({
              value: row.designation_id,
              label: row.designation_title,
            })),
          }));
        }
      });
  };

  GetGradeMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.grades;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Grade: data.map((row) => ({
              value: row.grade_id,
              label: row.grade_title,
            })),
          }));
        }
      });
  };

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Department: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };

  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };

  getStateAndDesignation = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios.get(`${apiURL}Payrolls/GetStatesAndDesignation`,
      { headers })
      .then((response) => {
        const { success } = response.data;
        console.log(response?.data);
        if (success === true) {

          // let rows1 = response?.data?.response?.states.map((val) => {
          //   return { value: val?.state_id, label: val?.state_title }
          // });
          this.setState((prevState) => ({
            state_options: response?.data?.response?.states?.map((row) => ({
              value: row.state_id,
              label: row.state_title,
            })),
          }));
        }
      });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validateForm();
    console.log("errors ==> ",errors);
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }
    const { apiURL, apiHeaderFile } = this.context;
    const headers = apiHeaderFile;
    const employee_id = this.props.params.employee_id;

    // Create a new FormData object
    const formData = new FormData();

    // Append form data to the FormData object
    formData.append('employee_id', employee_id || '');
    formData.append('blood_group', this.state.blood_Group || '');
    formData.append('reporting_manager_id', this.state.reporting_manager_id || '');
    formData.append('contract_from_date', this.state.From_date || '');
    formData.append('contract_to_date', this.state.To_date || '');
    formData.append('employee_title', this.state.Title || '');
    formData.append('employee_gender', this.state.employee_gender || '');
    formData.append('date_of_birth', this.state.Date_of_birth || '');
    formData.append('physically_challenged', this.state.physically_challenged || '');
    formData.append('international_employee', this.state.international_employee || '');
    formData.append('religion', this.state.religion || '');
    formData.append('nationality', this.state.nationality || '');
    formData.append('marital_status', this.state.marital_status || '');
    formData.append('employee_joining_date', this.state.employee_joining_date || '');
    formData.append('designation_id', this.state.designation_id || '');
    formData.append('department_id', this.state.department_id || '');
    formData.append('grade_id', this.state.grade_id || '');
    formData.append('is_contract_employee', this.state.is_contract_employee || '');
    formData.append('location_id', this.state.location_id || '');
    formData.append('employee_name', this.state.employee_name || '');
    formData.append('biometric_code',this.state.biometric_code || '');
    formData.append('employee_email_address', this.state.employee_email_address || '');
    formData.append('employee_official_email', this.state.employee_official_email || '');
    formData.append('employee_mobile_number', this.state.employee_mobile_number || '');
    formData.append('employee_address', this.state.employee_address || '');
    formData.append('employee_category', this.state.company_employee_category_id || '');
    formData.append('employee_type', this.state.company_employee_type_id || '');
    formData.append('employee_permanent_address', this.state.permanent_Address || '');
    formData.append('pin_code', this.state.pinCode || '');
    formData.append('employee_state', this.state.enter_State || '');
    formData.append('employee_profile_picture', this.state.profile_picture || '');
    formData.append('date', currentDateAndTime() || '');

    console.log("formData",...formData);

    axios.post(`${apiURL}Employees/UpdatePersonalDetails`, formData, { headers }).then((response) => {
      const { success } = response.data;
      if (success === true) {
        this.setState({
          profile_picture: null,
          blood_Group: '',
          employee_Code: '',
          designation: '',
          company_employee_category_id: null,
          company_employee_type_id: null,
          permanent_Address: '',
          pinCode: '',
          employee_Name: '',
          biometric_code: '',
          date_Of_Birth: '',
          physically_challenged: '',
          international_employee: '',
          religion: '',
          nationality: '',
          marital_status: '',
          date_Of_Joining: '',
          email: '',
          mobile_Number: '',
          enter_State: '',
          current_Address: '',
        });

        this.setState({ loadingList: true }, () => {
          this.GetInfo();
        });

        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          showConfirmButton: true,
          allowOutsideClick:false
        });
      } else {
        Swal.fire({
          title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
          text: response.data.message,
          icon: response.data.success === true ? 'success' : 'error',
          timer: 2000,
          showConfirmButton: true,
          allowOutsideClick: false,
        });

        this.setState({ loadingList: true }, () => {
        });
      }
    });
  };

  // Handler function to update state on input change
  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleSelectChange = (name, selectedOption) => {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  handleRadioChange = (name, value) => {

    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };

  validateForm = () => {
    const errors = {};
    // if (!this.state.Title) errors.Title = 'Title is required';
    if (!this.state.employee_gender) errors.employee_gender = 'GenderTitle is required';
    if (!this.state.employee_name) errors.employee_name = 'Employee name is required';
    if (!this.state.employee_mobile_number) errors.employee_mobile_number = 'Employee mobile number is required';
    // if (!this.state.employee_email_address) errors.employee_email_address = 'Employee personal email is required';
    // if (!this.state.employee_official_email) errors.employee_official_email = 'Employee work email is required';
    if (!this.state.Date_of_birth) errors.Date_of_birth = 'Date of birth is required';
    if (!this.state.employee_joining_date) errors.employee_joining_date = 'Employee joining date is required';
    // if (!this.state.reporting_manager_id) errors.reporting_manager_id = 'Reporting manager is required';
    if (!this.state.location_id) errors.location_id = 'Location is required';
    if (!this.state.department_id) errors.department_id = 'Department is required';
    if (!this.state.designation_id) errors.designation_id = 'Designation is required';
    if (!this.state.company_employee_type_id) errors.company_employee_type_id = 'Employee type is required';
    if (!this.state.company_employee_category_id) errors.company_employee_category_id = 'Employee category is required';
    if (!this.state.pinCode) errors.pinCode = 'Pin code is required';
    if (!this.state.enter_State) errors.enter_State = 'State is required';
    if (!this.state.employee_address) errors.employee_address = 'Employee address is required';
    
    if (!this.state.is_contract_employee) errors.is_contract_employee = 'This is required';

    if (this.state.is_contract_employee === '1') {
      if (!this.state.From_date) errors.From_date = 'From date is required';
      if (!this.state.To_date) errors.To_date = 'To date is required';
    }

    const mobileRegex = /^[0-9]{10}$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const pinCodeRegex = /^[0-9]{6}$/;

    if (this.state.employee_mobile_number && !mobileRegex.test(this.state.employee_mobile_number)) {
      errors.employee_mobile_number = 'Invalid mobile number';
    }

    if (this.state.employee_email_address && !emailRegex.test(this.state.employee_email_address)) {
      errors.employee_email_address = 'Invalid email address';
    }

    if (this.state.employee_official_email && !emailRegex.test(this.state.employee_official_email)) {
      errors.employee_official_email = 'Invalid work email address';
    }

    if (this.state.pinCode && !pinCodeRegex.test(this.state.pinCode)) {
      errors.pinCode = 'Invalid pin code';
    }

    return errors;
  };



  render() {
    const { errors } = this.state;

    return (
      <div>
        <h5>Personal Details</h5>
        <p className="text-muted">Fill all information below</p>

        <div className="container mt-2">
          <form onSubmit={this.handleSubmit}>
            <div className="row">
              {/* Profile Picture */}
              <div className="col-md-6 mb-1">
                  <label htmlFor="profile_pictureXX" className="form-label">Profile Picture:</label>
                  <br />
                  <div className=' d-flex align-items-center gap-2'>
                      {/* Display the profile picture */}
                      {this.state.selectedProfilePicture && (
                          <div
                              className="rounded-circle"
                              style={{
                                  width: "55px",
                                  height: "55px",
                                  overflow: "hidden",
                                  border:"1.5px solid #6464f4",
                                  // marginRight: "10px",
                              }}
                          >
                              <img
                                  src={this.state.selectedProfilePicture || this.state.profileUrl }
                                  alt="Profile"
                                  style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                  }}
                              />
                          </div>
                      )}
                      <div className=' d-flex align-items-center gap-3'>
                          {/* upload profile picture */}
                          {!this.state.selectedProfilePictureName && (
                              <div>
                                  <label htmlFor="profile_picture" className="btn btn-primary">
                                      Choose File
                                  </label>
                                  <input
                                      type="file"
                                      id="profile_picture"
                                      name="profile_picture"
                                      accept="image/*"
                                      onChange={this.handleFileChange}
                                      className="form-control d-none"
                                  />
                              </div>
                          )}
                          {this.state.selectedProfilePictureName && (
                          <div className="mt-2 d-flex align-items-center mb-3">
                              
                              <div className="d-flex align-items-center">
                                  <div
                                  >
                                      <small className=' text-muted'>
                                      Selected file:
                                      </small><br/>
                                      <h6
                                      className="text-truncate mb-0"
                                      style={{
                                          maxWidth: "16rem", // Adjust max width to fit within the parent div
                                          overflow: "hidden",
                                          whiteSpace: "nowrap",
                                          textOverflow: "ellipsis",
                                      }}>{this.state.selectedProfilePictureName}</h6> 
                                  </div>
                                  <button
                                      type="button"
                                      className="btn-close ms-2"
                                      aria-label="Close"
                                      onClick={this.removeProfilePicture}
                                  ></button>
                              </div>
                          </div>
                          )}
                          
                      </div>
                  </div>
                  {this.state.fileError && ( <small className=' text-danger'>{this.state.fileError}</small> )}
              </div>
              {/* Title */}
              <div className="col-md-6 mb-3">
                <label htmlFor="Title" className="form-label">Title:</label>
                <Select id="Title" name="Title"
                  onChange={(selectedOption) => this.handleSelectChange('Title', selectedOption)}
                  options={titleOptions}
                  placeholder="Select title" 
                  value={this.state.Title ? titleOptions.find(option => option.value === this.state.Title) : null}/>
                {/* {errors.Title && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }} >{errors.Title}</div>} */}
              </div>
              {/* Employee Name */}
              <div className="col-md-6 mb-3">
                <label htmlFor="employee_name" className="form-label">Employee Name:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <input
                  type="text"
                  id="employee_name"
                  name="employee_name"
                  value={this.state.employee_name}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.employee_name ? 'is-invalid' : ''}`}
                  placeholder="Enter employee name" />

                {errors.employee_name && <div className="invalid-feedback">{errors.employee_name}</div>}
              </div>
              {/* Biometric Code */}
              <div className="col-md-6 mb-3">
                <label htmlFor="biometric_code" className="form-label">Biometric Code:</label>
                <input
                  type="text"
                  id="biometric_code"
                  name="biometric_code"
                  value={this.state.biometric_code}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.biometric_code ? 'is-invalid' : ''}`}
                  placeholder="Enter Biometric Code" />
                {/* {errors.biometric_code && <div className="invalid-feedback">{errors.biometric_code}</div>} */}
              </div>
              {/* Contact No */}
              <div className="col-md-6 mb-3">
                <label htmlFor="employee_mobile_number" className="form-label">Contact No:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <input
                  type="number"
                  id="employee_mobile_number"
                  name="employee_mobile_number"
                  value={this.state.employee_mobile_number}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.employee_mobile_number ? 'is-invalid' : ''}`}
                  placeholder="Enter Contact" />
                {errors.employee_mobile_number && <div className="invalid-feedback">{errors.employee_mobile_number}</div>}
              </div>
              {/* Gender */}
              <div className="col-md-6 mb-3">
                <label htmlFor="employee_gender" className="form-label">Gender:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <Select
                  id="employee_gender"
                  name="employee_gender"
                  onChange={(selectedOption) => this.handleSelectChange('employee_gender', selectedOption)}
                  options={genderOptions}
                  placeholder="Select gender" 
                  value={this.state.employee_gender ? genderOptions.find(option => option.value === this.state.employee_gender) : null}/>
                {errors.employee_gender && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }} >{errors.employee_gender}</div>}
              </div>
              {/* Personal Email */}
              <div className="col-md-6 mb-3">
                <label htmlFor="employee_email_address" className="form-label">Personal Email:</label>
                <input
                  type="email"
                  id="employee_email_address"
                  name="employee_email_address"
                  value={this.state.employee_email_address}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.employee_email_address ? 'is-invalid' : ''}`}
                  placeholder="Enter employee's personal email" />
                {/* {errors.employee_email_address && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }}>{errors.employee_email_address}</div>} */}
              </div>
              {/* Work Email */}
              <div className="col-md-6 mb-3">
                <label htmlFor="employee_official_email" className="form-label">Work Email:</label>
                <input
                  type="email"
                  id="employee_official_email"
                  name="employee_official_email"
                  value={this.state.employee_official_email}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.employee_official_email ? 'is-invalid' : ''}`}
                  placeholder="Enter employee's work email" />
                {/* {errors.employee_official_email && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }}>{errors.employee_official_email}</div>} */}
              </div>
              {/* Date Of Birth */}
              <div className="col-md-6 mb-3">
                <label htmlFor="Date_of_birth" className="form-label">Date Of Birth:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <input
                  type="date"
                  id="Date_of_birth"
                  name="Date_of_birth"
                  value={this.state.Date_of_birth}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.Date_of_birth ? 'is-invalid' : ''}`} />
                {errors.Date_of_birth && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }}>{errors.Date_of_birth}</div>}
              </div>
              {/* Physically Challenged */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Physically Challenged:</label><br/>
                <div className="form-check form-check-inline mt-2" >
                  <input
                    type="radio"
                    id="physically_challenged1"
                    name="physically_challenged"
                    value="1"
                    checked={this.state.physically_challenged === '1'}
                    onChange={() => this.handleRadioChange('physically_challenged', '1')}
                    className={`form-check-input ${errors.physically_challenged ? 'is-invalid' : ''}`}
                  />
                  <label htmlFor="physically_challenged1" className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="physically_challenged0"
                    name="physically_challenged"
                    value="0"
                    checked={this.state.physically_challenged === '0'}
                    onChange={() => this.handleRadioChange('physically_challenged', '0')}
                    className={`form-check-input ${errors.physically_challenged ? 'is-invalid' : ''}`}
                    />
                  <label htmlFor="physically_challenged0" className="form-check-label">No</label>
                </div>
              </div>
              {/* International Employee */}
              <div className="col-md-6 mb-3">
                <label className="form-label">International Employee:</label><br/>
                <div className="form-check form-check-inline mt-2" >
                  <input
                    type="radio"
                    id="international_employee1"
                    name="international_employee"
                    value="1"
                    checked={this.state.international_employee === '1'}
                    onChange={() => this.handleRadioChange('international_employee', '1')}
                    className={`form-check-input ${errors.international_employee ? 'is-invalid' : ''}`}
                  />
                  <label htmlFor="international_employee1" className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="international_employee0"
                    name="international_employee"
                    value="0"
                    checked={this.state.international_employee === '0'}
                    onChange={() => this.handleRadioChange('international_employee', '0')}
                    className={`form-check-input ${errors.international_employee ? 'is-invalid' : ''}`}
                    />
                  <label htmlFor="international_employee0" className="form-check-label">No</label>
                </div>
              </div>
              {/* Religion */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Religion:</label>
                 <input
                  type="text"
                  id="religion"
                  name="religion"
                  value={this.state.religion}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.religion ? 'is-invalid' : ''}`}
                  placeholder="Enter Religion" />
              </div>
              {/* Nationality */}
              <div className="col-md-6 mb-3">
                <label className="form-label">Nationality:</label>
                 <input
                  type="text"
                  id="nationality"
                  name="nationality"
                  value={this.state.nationality}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.nationality ? 'is-invalid' : ''}`}
                  placeholder="Enter Nationality" />
              </div>
              {/* Marital Status */}
              <div className="col-md-6 mb-3">
                <label htmlFor="marital_status" className="form-label">Marital Status:</label>
                <Select
                  onChange={(selectedOption) => this.handleSelectChange('marital_status', selectedOption)}
                  options={maritalStatusOptions}
                  placeholder={`Select reporting manager`} 
                  value={this.state.marital_status ? maritalStatusOptions.find(option => option.value === this.state.marital_status) : null}/>
              </div>
              {/* Joining Date */}
              <div className="col-md-6 mb-3">
                <label htmlFor="employee_joining_date" className="form-label">Joining Date:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <input
                  type="date"
                  id="employee_joining_date"
                  name="employee_joining_date"
                  value={this.state.employee_joining_date}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.employee_joining_date ? 'is-invalid' : ''}`} />
                {errors.employee_joining_date && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }}>{errors.employee_joining_date}</div>}
              </div>
              {/* Reporting Manager */}
              <div className="col-md-6 mb-3">
                <label htmlFor="reporting_Manager" className="form-label">Reporting Manager:</label>
                <Select
                  onChange={(selectedOption) => this.handleSelectChange('reporting_manager_id', selectedOption)}
                  value={this.state.reporting_manager_id ? this.state.employee_verified_row.find(option => option.value === this.state.reporting_manager_id) : null}
                  placeholder={`Select reporting manager`} options={this.state.employee_verified_row} />
                {/* {errors.reporting_manager_id && <div className="text-danger">{errors.reporting_manager_id}</div>} */}
              </div>
              {/* Contract Employees */}
              <div className="col-md-6 mb-3">
                <div>
                  <label htmlFor="is_contract_employee" className="form-label"> Contract Employees:
                    <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                  </label>
                </div>
                <div className="form-check form-check-inline mt-2" >
                  <input
                    type="radio"
                    id="is_contract_employee1"
                    name="is_contract_employee"
                    value="1"
                    checked={this.state.is_contract_employee == '1'}
                    onChange={() => this.handleRadioChange('is_contract_employee', '1')}
                    className={`form-check-input ${errors.is_contract_employee ? 'is-invalid' : ''}`}
                  />
                  <label htmlFor="is_contract_employee1" className="form-check-label">Yes</label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    type="radio"
                    id="is_contract_employee0"
                    name="is_contract_employee"
                    value="0"
                    checked={this.state.is_contract_employee == '0'}
                    onChange={() => this.handleRadioChange('is_contract_employee', '0')}
                    className={`form-check-input ${errors.is_contract_employee ? 'is-invalid' : ''}`}
                    />
                  <label htmlFor="is_contract_employee0" className="form-check-label">No</label>
                </div>
                    {errors?.is_contract_employee && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }}>{errors?.is_contract_employee}</div>}
              </div>
              {/* From Date and To Date*/}
              {this.state.is_contract_employee == '1' && <>
                {/* From Date */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="From_date" className="form-label"> From Date
                    <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                  </label>
                  <input
                    type="date"
                    id="From_date"
                    name="From_date"
                    value={this.state.From_date}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.From_date ? 'is-invalid' : ''}`}
                  />
                  {errors?.From_date && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }}>{errors?.From_date}</div>}
                </div>
                {/* To Date */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="To_date" className="form-label"> To Date:
                    <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                  </label>
                  <input
                    type="date"
                    id="To_date"
                    name="To_date"
                    value={this.state.To_date}
                    onChange={this.handleInputChange}
                    className={`form-control ${errors.To_date ? 'is-invalid' : ''}`}
                  />
                  {errors.To_date && <div className="invalid-feedback">{errors.To_date}</div>}
                </div>
              </>}
              {/* State */}
              <div className="col-md-6 mb-3">
                <label htmlFor="enter_State" className="form-label">State:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <Select
                  onChange={(selectedOption) => this.handleSelectChange('enter_State', selectedOption)}
                  options={this.state.state_options}
                  placeholder={`Select State`} 
                  value={ this.state.enter_State ? this.state.state_options.find(option => option.value === this.state.enter_State) : null }
                />
                {errors.enter_State && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }}>{errors.enter_State}</div>}
              </div>
              {/* Location */}
              <div className="col-md-6 mb-3">
                <label htmlFor="Location" className="form-label">Location:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <Select
                  onChange={(selectedOption) => this.handleSelectChange('location_id', selectedOption)}
                  options={this.state.Location}
                  placeholder={`Select location`} 
                  value={this.state.location_id ? this.state.Location.find(option => option.value === this.state.location_id) : null}
                />
                {errors.location_id && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }} >{errors.location_id}</div>}
              </div>
              {/* Department */}
              <div className="col-md-6 mb-3">
                <label htmlFor="Department" className="form-label">Department:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <Select
                  onChange={(selectedOption) => this.handleSelectChange('department_id', selectedOption)}
                  options={this.state.Department}
                  placeholder={`Select department`} 
                  value={this.state.department_id ? this.state.Department.find(option => option.value === this.state.department_id) : null}
                />
                {errors.department_id && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }} >{errors.department_id}</div>}
              </div>
              {/* Designation */}
              <div className="col-md-6 mb-3">
                <label htmlFor="Designation" className="form-label">Designation:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <Select
                  onChange={(selectedOption) => this.handleSelectChange('designation_id', selectedOption)}
                  options={this.state.Designation}
                  placeholder={`Select designation`} 
                  value={this.state.designation_id ? this.state.Designation.find(option => option.value === this.state.designation_id) : null}
                />
                {errors.designation_id && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }} >{errors.designation_id}</div>}

              </div>
              {/* Grade */}
              <div className="col-md-6 mb-3">
                <label htmlFor="Grade" className="form-label">Grade</label>
                <Select
                  onChange={(selectedOption) => this.handleSelectChange('grade_id', selectedOption)}
                  options={this.state.Grade}
                  placeholder={`Select grade`} 
                  value={this.state.grade_id ? this.state.Grade.find(option => option.value === this.state.grade_id) : null}
                />
              </div>

              {/* <div className="col-md-6 mb-3">
                <label htmlFor="profile_pictureXX" className="form-label">Profile Picture:</label><br />
                <label htmlFor="profile_picture" className="btn btn-primary">
                  Choose File
                </label>
                <input
                  type="file"
                  id="profile_picture"
                  name="profile_picture"
                  onChange={this.handleFileChange}
                  className="form-control d-none"
                />
                {this.state.selectedProfilePictureName && (
                  <div className="mt-2 d-flex align-items-center">
                    <span>Selected file: {this.state.selectedProfilePictureName}</span>
                    <button
                      type="button"
                      className="btn-close ms-2"
                      aria-label="Close"
                      onClick={this.removeProfilePicture}>
                    </button>
                  </div>
                )}
              </div> */}
              {/* Blood Group */}
              <div className="col-md-6 mb-3">
                <label htmlFor="blood_Group" className="form-label">Blood Group:</label>
                <Select id="blood_Group" name="blood_Group"
                  onChange={(selectedOption) => this.handleSelectChange('blood_Group', selectedOption)}
                  options={bloodGroupOptions}
                  placeholder="Select blood group" 
                  value={bloodGroupOptions.find(option => option.value === this.state.blood_Group)}
                />
              </div>
              {/* Employee Type */}
              <div className="col-md-6 mb-3">
                <label htmlFor="company_employee_type_id" className="form-label">Employee Type:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <Select
                  id="company_employee_type_id"
                  name="company_employee_type_id"
                  value={this.state.employee_type_row.find(option => option.value == this.state.company_employee_type_id)}
                  onChange={(selectedOption) => this.handleSelectChange('company_employee_type_id', selectedOption)}
                  options={this.state.employee_type_row}
                  placeholder="Select employee type" />

                {errors.company_employee_type_id && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }} >{errors.company_employee_type_id}</div>}
              </div>
              {/* Employee Category */}
              <div className="col-md-6 mb-3">
                <label htmlFor="company_employee_category_id" className="form-label">Employee Category:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <Select id="company_employee_category_id" name="company_employee_category_id"
                  onChange={(selectedOption) => this.handleSelectChange('company_employee_category_id', selectedOption)}
                  options={this.state.employee_category_row}
                  placeholder="Select employee category" 
                  value={this.state.employee_category_row.find(option => option.value == this.state.company_employee_category_id)}
                />

                {errors.company_employee_category_id && <div className="text-danger" style={{ width: '100%', marginTop: '.25rem', fontSize: '.875em' }} >{errors.company_employee_category_id}</div>}
              </div>
              {/* Pin Code */}
              <div className="col-md-6 mb-3">
                <label htmlFor="pinCode" className="form-label">Pin Code:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <input
                  type="text"
                  id="pinCode"
                  name="pinCode"
                  value={this.state.pinCode}
                  onChange={this.handleInputChange}
                  className={`form-control ${errors.pinCode ? 'is-invalid' : ''}`}
                  placeholder="Enter pin code" />
                {errors.pinCode && <div className="invalid-feedback">{errors.pinCode}</div>}
              </div>
              {/* Current Address */}
              <div className="col-md-6 mb-3">
                <label htmlFor="employee_address" className="form-label">Current Address:
                  <span style={{ color: "blue", borderRadius: "50%", background: "#f0f8ff", padding: "2px 6px", display: "inline-block", textAlign: "center", width: "20px", height: "20px", lineHeight: "20px", }}>*</span>
                </label>
                <textarea id="employee_address"
                name="employee_address"
                value={this.state.employee_address}
                onChange={this.handleInputChange}
                className={`form-control ${errors.employee_address ? 'is-invalid' : ''}`}
                placeholder="Enter Employee Permanent Address" />
                {errors.employee_address && <div className="invalid-feedback">{errors.employee_address}</div>}
              </div>
              {/* Permanent Address */}
              <div className="col-md-6 mb-3">
                <label htmlFor="permanent_Address" className="form-label">Permanent Address:</label>
                <textarea id="permanent_Address"
                name="permanent_Address"
                value={this.state.permanent_Address}
                onChange={this.handleInputChange}
                className={`form-control ${errors.permanent_Address ? 'is-invalid' : ''}`}
                placeholder="Enter Employee Permanent Address" />
                {errors.permanent_Address && <div className="invalid-feedback">{errors.permanent_Address}</div>}
              </div>
            </div>
            <div className="mt-4" style={{ float: "right" }}>
              <button type="submit" className="btn btn-success btn-label waves-effect right waves-light">
                <i className="bx bx-save label-icon align-middle fs-16 ms-2" /> Save
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(PersonalDetails);
